import { Box, Button, Container, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePack } from '../api/usePack';
import { TypographyPackStatus } from '@features/typography-colored-status-pack';
import { BATCH_STATUSES } from '@shared/api/constants';
import { Alert } from '@features/alert';
import { LoadingButton } from '@mui/lab';
import { LoadingPage } from '@widgets/loading-page';

export const PackPage = () => {
    const { id: packId } = useParams();

    const {
        alertRef, pack, loading, isLoading,
        handleStartPacking,
        handleFinishPacking,
    } = usePack(packId);

    if (isLoading) return <LoadingPage/>;

    return (
        <>
            <Container
                maxWidth="sm"
                sx={{
                    width: { xs: '100%', md: 'auto' },
                    padding: { xs: 2, sm: 3, md: 3 },
                    height: '80vh',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start', // Align to the left
                        marginBottom: 2, // Add spacing below the button
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to={`../packs`}
                    >
                        back
                    </Button>
                </Box>
                <>
                    <Paper sx={{
                        flexGrow: 1, // Allow Paper to take up remaining space
                        overflow: 'auto', // Enable scrolling for content
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'auto',
                        backgroundColor: '#f9f9f9',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                        borderRadius: 2
                    }}>
                        <Grid container spacing={1}>
                            <Grid size={{ xs: 12 }}>
                                <Box display="flex" justifyContent="space-between"
                                     sx={{ borderBottom: '1px solid #ccc', pb: 2 }}>
                                    <Typography variant="h5">pack information</Typography>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 8 }}>
                                <Typography variant="body1">{pack?.country?.name} {pack?.producerName}</Typography>
                            </Grid>
                            <Grid size={{ xs: 4 }}>
                                <TypographyPackStatus status={pack?.status} variant="body1"/>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="body1"><strong>roast type:</strong> {pack?.roastType?.name?.en}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="body1"><strong>grind:</strong> {pack?.grind}</Typography>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="body1"><strong>weight:</strong> {pack?.weight} kg</Typography>
                            </Grid>
                            {pack?.status === BATCH_STATUSES.IN_PROGRESS && (
                                <Grid size={{ xs: 12 }}>
                                    <Typography variant="body1">
                                        <strong>bucket:</strong> {pack?.batch?.bucket?.shortId}
                                    </Typography>
                                </Grid>
                            )}
                            <Grid size={{ xs: 12 }}>
                                {pack?.status === BATCH_STATUSES.INITIALIZED && (
                                    <LoadingButton
                                        variant="contained"
                                        color="success"
                                        loading={loading}
                                        onClick={handleStartPacking}
                                    >
                                        start packing
                                    </LoadingButton>
                                )}
                                {pack?.status === BATCH_STATUSES.IN_PROGRESS && (
                                    <LoadingButton
                                        variant="contained"
                                        color="warning"
                                        onClick={handleFinishPacking}
                                        loading={loading}
                                    >
                                        confirm packing
                                    </LoadingButton>
                                )}
                            </Grid>
                        </Grid>
                    </Paper>
                </>
            </Container>
            <Alert ref={alertRef}/>
        </>
    );
};